'use client'

import { useEffect } from 'react'

import {
  ATTRIBUTION_COOKIE,
  attributionCookieString,
  buildAttribution,
  hasPaidClickId,
  nextAttribution,
  parseAttributionCookie,
  parseCookieString,
  parseUrlAttribution,
} from '@/lib/attribution/attribution'

/**
 * Writes the first-touch `cg_attr` cookie once per page load
 * (marketing/conversion-events/site-tracking-contract.md section 4). Renders
 * nothing; every rule it applies lives in src/lib/attribution/attribution.ts.
 *
 * First touch wins: an existing cookie is left alone unless the current URL
 * carries a paid click id, which is a fresh paid visit worth re-attributing.
 */
export function AttributionCapture() {
  useEffect(() => {
    try {
      const cookies = parseCookieString(document.cookie)
      const existing = parseAttributionCookie(cookies[ATTRIBUTION_COOKIE])
      const url = window.location.href
      const candidate = buildAttribution({
        url,
        referrer: document.referrer,
        cookies,
        capturedAt: new Date().toISOString(),
      })
      const write = nextAttribution(existing, candidate, {
        urlHasPaidClickId: hasPaidClickId(parseUrlAttribution(url)),
      })
      if (!write) return
      document.cookie = attributionCookieString(write, {
        hostname: window.location.hostname,
        secure: window.location.protocol === 'https:',
      })
    } catch {
      // Attribution is never worth breaking a page over.
    }
  }, [])

  return null
}

export default AttributionCapture
